<template>
    <div>
        <main-info :company="companyData"></main-info>
        <presentation :company="companyData"></presentation>
        <quality-assurance
            :certificates="companyData.Certificates"
            :quality="companyData.Quality"
            :orgNr="companyData.OrgNr"
        ></quality-assurance>
        <ratings
            v-if="companyData.Ratings.length > 0"
            :company="companyData"
            :ratings="companyData.Ratings"
        ></ratings>
        <reference-jobs
            v-if="companyData.References.length > 0"
            :references="companyData.References"
            :companyName="companyData.Name"
        ></reference-jobs>
    </div>
</template>

<script>
    import Ratings from '../components/organisms/my-pages-sections/company/profile/OrganismMyPagesRatings.vue'
    import Presentation from '../components/organisms/my-pages-sections/company/profile/OrganismMyPagesPresentation.vue'
    import MainInfo from '../components/organisms/my-pages-sections/company/profile/OrganismMyPagesMainInfo.vue'
    import QualityAssurance from '../components/organisms/my-pages-sections/company/profile/OrganismMyPagesQualityAssurance.vue'
    import ReferenceJobs from '../components/organisms/my-pages-sections/company/profile/OrganismMyPagesReferenceJobs.vue'

    export default {
        props: [
            'companyData',
        ],
        components: {
            Ratings,
            Presentation,
            MainInfo,
            QualityAssurance,
            ReferenceJobs,
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/my-pages-sublayouts/MyPagesProfile.vue